import { Box, Button, Tooltip, Typography } from '@mui/material';
import { green, grey, red } from '@mui/material/colors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { inject, observer } from 'mobx-react';
import ReactComponent from '@/components/ReactComponent';
import { AccessTime, CheckCircleOutline, Delete, Download, ErrorOutline } from '@mui/icons-material';
import { makeObservable, observable } from 'mobx';
import ModalConfirmacao from '@/components/sessao/ModalConfirmacao';
dayjs.extend(customParseFormat);
import { enqueueSnackbar } from 'notistack';

const FORMATO_DATA_DOCUMENTO = 'DD-MM-YYYY-HH-mm-ss';
const FORMATO_SAIDA_DATA_DOCUMENTO = 'DD/MM/YYYY [às] HH:mm:ss';

class DocumentoRepresentante extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            openModalConfirmacaoExclusao: observable
        });
    }

    openModalConfirmacaoExclusao = false;

    handleDownloadDocumento = async () => {
        const response = await this.sessaoService.downloadDocumento(this.observableProps.id);
        const href = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', this.observableProps.nome);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    };

    handleExclusaoDocumento = async () => {
        try {
            await this.advogadoSustentacaoOralService.removerDocumento(this.observableProps.id);
            this.observableProps.onRemoveDocumento();
            enqueueSnackbar({
                variant: 'success',
                message: 'Documento removido com sucesso.'
            });
        } catch (err) {
            console.error(err);
            enqueueSnackbar({
                variant: 'warning',
                message: 'Erro ao remover o documento. Tente novamente.'
            });
        }
    };

    handleOpenModalConfirmacaoExclusao = () => {
        this.openModalConfirmacaoExclusao = true;
    };

    handleCloseModalConfirmacaoExclusao = () => {
        this.openModalConfirmacaoExclusao = false;
    };

    getValidacao = () => {
        let icone = <AccessTime sx={{ color: grey[500] }} />;
        let tooltipTitle = 'Aguardando avaliação da Secretaria.';

        if (this.observableProps.documentoValidacao?.validado === true) {
            icone = <CheckCircleOutline sx={{ color: green[500] }} />;
            tooltipTitle = `Documento aprovado em ${dayjs(this.observableProps.documentoValidacao?.dataValidacao, FORMATO_DATA_DOCUMENTO).format(FORMATO_SAIDA_DATA_DOCUMENTO)}.`;
        } else if (this.observableProps.documentoValidacao?.validado === false) {
            icone = <ErrorOutline sx={{ color: red[500] }} />;
            tooltipTitle = `Documento reprovado em ${dayjs(this.observableProps.documentoValidacao?.dataValidacao, FORMATO_DATA_DOCUMENTO).format(FORMATO_SAIDA_DATA_DOCUMENTO)}. Motivo da reprovação: ${this.observableProps.documentoValidacao?.motivoReprovacao ?? '-'}`;
        }

        return <Tooltip title={<Typography>{tooltipTitle}</Typography>}>{icone}</Tooltip>;
    };

    render() {
        return (
            <Box
                sx={{
                    padding: 2,
                    border: `1px solid ${grey[300]}`,
                    borderRadius: 3,
                    mt: 1
                }}
            >
                {this.observableProps.excluido ? (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            textDecoration: 'line-through',
                            color: grey[400]
                        }}
                    >
                        <Tooltip title="Documento excluído">
                            <span>
                                <strong>Nome do arquivo:</strong> {this.observableProps.nome}
                            </span>
                        </Tooltip>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        {this.observableProps.exibirStatus && (
                            <Box sx={{ display: 'flex', mr: 2 }}>{this.getValidacao()}</Box>
                        )}
                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            <span>
                                <strong>Nome do arquivo:</strong> {this.observableProps.nome}
                            </span>
                            <span>
                                <strong>Data de envio:</strong>{' '}
                                {dayjs(this.observableProps.dataDocumento, FORMATO_DATA_DOCUMENTO).format(
                                    FORMATO_SAIDA_DATA_DOCUMENTO
                                )}
                            </span>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                            <Tooltip title={<Typography>Fazer o download do arquivo</Typography>}>
                                <Button onClick={this.handleDownloadDocumento}>
                                    <Download />
                                </Button>
                            </Tooltip>
                            <Tooltip title={<Typography>Remover o arquivo</Typography>}>
                                <Button
                                    color="error"
                                    onClick={this.handleOpenModalConfirmacaoExclusao}
                                >
                                    <Delete />
                                </Button>
                            </Tooltip>
                        </Box>
                    </Box>
                )}
                <ModalConfirmacao
                    open={this.openModalConfirmacaoExclusao}
                    callbackConfirmar={this.handleExclusaoDocumento}
                    callbackCancelar={this.handleCloseModalConfirmacaoExclusao}
                    titulo={'Remoção de documento'}
                >
                    <Typography>Tem certeza que deseja remover esse documento?</Typography>
                </ModalConfirmacao>
            </Box>
        );
    }
}

export default inject('stores')(observer(DocumentoRepresentante));
